import React from "react";
import { usePhaseColors } from "../hooks/usePhaseColors";
import { PHASE_KEYS, PHASE_LABELS } from "../constants/phases";

export const Legend: React.FC = () => {
  const colors = usePhaseColors();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "2rem",
        marginTop: "1rem",
        flexWrap: "wrap",
      }}
    >
      {PHASE_KEYS.map((phase) => (
        <div
          key={phase}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            fontSize: "1.2rem",
            color: "#cbd5e1",
          }}
        >
          <div
            style={{
              width: "1rem",
              height: "1rem",
              borderRadius: "50%",
              backgroundColor: colors[phase],
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          />
          <span>{PHASE_LABELS[phase]}</span>
        </div>
      ))}
    </div>
  );
};
